import { useState } from 'react'

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [erro, setErro] = useState('')
  const [loading, setLoading] = useState(false)

  const BASE = process.env.REACT_APP_API_URL

  const handleSubmit = async (e) => {
    e.preventDefault()
    setErro('')
    setLoading(true)
    try {
      const res = await fetch(`${BASE}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.error || 'Erro ao fazer login')
      localStorage.setItem('zf_token', data.token)
      onLogin()
    } catch (err) {
      setErro(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg)',
      fontFamily: 'Georgia, serif',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        background: 'var(--card-bg)', border: '1px solid var(--card-border)',
        borderRadius: '22px', padding: '2.5rem 2rem',
        width: '100%', maxWidth: '380px',
        boxShadow: '0 4px 24px var(--shadow)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <img src="/Logo.webp" alt="ZF Locadora" style={{ height: '52px', objectFit: 'contain' }} />
          <p style={{ fontSize: '12px', letterSpacing: '0.14em', color: 'var(--text-secondary)', marginTop: '0.75rem', textTransform: 'uppercase' }}>
            Acesso ao Sistema
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="field" style={{ marginBottom: '1rem' }}>
            <label>Usuário</label>
            <input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoFocus
              required
            />
          </div>
          <div className="field" style={{ marginBottom: '1.5rem' }}>
            <label>Senha</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>

          {erro && <div className="badge-err" style={{ marginBottom: '1rem' }}>{erro}</div>}

          <button type="submit" className="btn-gold" disabled={loading}>
            {loading ? 'ENTRANDO...' : 'ENTRAR'}
          </button>
        </form>
      </div>
    </div>
  )
}
